/*
 * Copyright (c) 2020.
 * Project: Source
 * LastModified: 2/14/20, 3:23 PM
 * Author: diengv < Giáp Văn Điện >
 * Email: diengv@ominext.com
 * File name: index.js
 * File path: D:/Projects/PMS/Source/Client/vuejs/src/plugins/bulma/index.js
 */

import BulmaNav from './component/Navbar'
import ModalCard from './component/modal-card'
import Slide from './component/slider'
import NumberInput from './component/number-input'
import FieldInput from './component/field-input'
import InputDropdown from './component/input-dropdown'

export default {
  install (Vue, options) {
    Vue.component('bulma-nav', BulmaNav)
    Vue.component('bulma-modal-card', ModalCard)
    Vue.component('bulma-slide', Slide)
    Vue.component('bulma-number-input', NumberInput)
    Vue.component('bulma-field-input', FieldInput)
    Vue.component('bulma-input-dropdown', InputDropdown)
  }
}
